import React from 'react';
import GammaChart from './GammaChart';
import GammaMetricSelector from './GammaMetricSelector';
import { GammaExposurePoint, GammaMetricKey, StockDataPoint } from '../types/StockData';

interface GammaTabProps {
  gammaData: GammaExposurePoint[];
  gammaLoading: boolean;
  selectedGammaMetric: GammaMetricKey;
  onGammaMetricChange: (metric: GammaMetricKey) => void;
  selectedDataPoint: StockDataPoint | null;
  data: StockDataPoint[];
}

const GammaTab: React.FC<GammaTabProps> = ({
  gammaData,
  gammaLoading,
  selectedGammaMetric,
  onGammaMetricChange,
  selectedDataPoint,
  data
}) => {
  if (gammaLoading) {
    return (
      <div className="text-center py-4 text-gray-500">
        Loading gamma exposure data...
      </div>
    );
  }

  if (gammaData.length === 0) {
    return (
      <div className="text-center py-4 text-gray-500">
        No gamma exposure data available
      </div>
    );
  }

  const currentPrice = selectedDataPoint?.price || data[data.length - 1]?.price || 180;

  return (
    <div className="space-y-4">
      <GammaMetricSelector
        selectedMetric={selectedGammaMetric}
        onMetricChange={onGammaMetricChange}
      />
      <GammaChart
        data={gammaData}
        selectedMetric={selectedGammaMetric}
        currentPrice={currentPrice}
      />
    </div>
  );
};

export default GammaTab;
